import { render } from "./BaseInput.vue?vue&type=template&id=31b8ffa6"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"
script.render = render

export default script